export default __webpack_public_path__ + "static/media/relatorios.9a841b33.svg";